import styled from 'styled-components';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
import { Wrapper as Input } from '@spa/shared/components/Unisystem/Input/styles';
import { DayContainer } from '@spa/shared/components/MoveInOutPicker/styles';
import { WrapperDesktop as Calendar } from '@spa/shared/components/Unisystem/Calendar/styles';
export var OuterWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-0"
})(["position:sticky;top:72px;z-index:2;"]);
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-1"
})(["display:flex;flex-direction:column;gap:", ";width:100%;background:", ";box-shadow:0px 5px 20px 0px ", ";border-radius:12px;padding:", ";z-index:1;color:", ";> ", "{width:100%;}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.pricingBox.background;
}, function (props) {
  return props.theme.pricingBox.shadow;
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, Button);
export var ReserveWarning = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-2"
})(["display:flex;", ";align-items:center;font-size:", ";line-height:", ";color:", ";font-weight:600;"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.pricingBox.price.tertiaryColor;
});
export var PriceSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-3"
})(["display:flex;justify-content:space-between;align-items:center;& > span{display:flex;align-items:center;gap:", ";svg{g{path{stroke:", ";}}}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.colors.blueDianne;
});
export var Price = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-4"
})(["font-size:", ";line-height:", ";font-weight:600;span{color:", ";font-weight:500;font-size:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.pricingBox.price.secondaryColor;
}, function (props) {
  return props.theme.rem(16);
});
export var DatesSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-5"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";", "{width:45%;cursor:pointer;input{cursor:pointer;}}svg{width:64px;}"], function (props) {
  return props.theme.space(1);
}, Input);
export var CalendarWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bci2fn-6"
})(["position:absolute;top:80px;right:-16px;", "{max-height:80vh;}", ""], Calendar, function (props) {
  return props.hasSelectedDates && "\n      ".concat(DayContainer, " {\n        cursor: default;\n      }\n  ");
});